module.exports = __webpack_public_path__ + "assets/PTS75F-webfont.df1e159f56aa693cd3ddd1167071de069d4ea96c6d97976e1b9025b85690f34c.woff2";